import AnalyticsRoutes from '@/analytics/main/AnalyticsRoutes';
import AuthGuard from '@/auth/main/route-guard/AuthGuard';
import CertPermRoutes from '@/certperm/main/CertPermRoutes';
import CustomersRoutes from '@/customers/main/CustomersRoutes';
import DashboardRoutes from '@/dashboard/main/DashboardRoutes';
import EmployeesRoutes from '@/employees/main/EmployeesRoutes';
import EquipmentRoutes from '@/equipments/main/EquipmentRoutes';
import JobSitesRoutes from '@/jobSites/main/JobSitesRoutes';
import JobsRoutes from '@/jobs/main/JobsRoutes';
import Layout from '@/common/presentation/components/layout/Layout';
import { NotFound } from '@/common/presentation/components/NotFound/NotFound';
import QuotesRoutes from '@/quotes/main/QuotesRoutes';
import RaptorJobRoutes from '@/raptorjob/main/RaptorJobRoutes';
import SomethingWentWrong from '@/common/presentation/components/SomethingWentWrong/SomethingWentWrong';
import TimesheetsRoutes from '@/timesheets/main/TimesheetsRoutes';
import UserManagementRoutes from '@/userManagement/main/UserManagementRoutes';
import { getGoogleMapsApiKey } from '@/common/application/utils/getGoogleMapsApiKey';
import { isRunningLocally } from '@/common/infrastructure/config/env';
import { APIProvider } from '@vis.gl/react-google-maps';
import Loadable from '@/common/presentation/components/utils/Loader/Loadable';
import { lazy } from 'react';

const DashboardTab = Loadable(lazy(() => import('@/dashboard/presentation')));
const MapOverviewTab = Loadable(lazy(() => import('@/map/presentation/pages/MapOverviewTab')));
const UserPreferencesPage = Loadable(lazy(() => import('@/common/presentation/pages/UserPreferencesPage')));

// Resolve Google Maps API key once and guard downstream renders
const mapsApiKey = getGoogleMapsApiKey();

const MainRaptorRoutes = [
  {
    index: true,
    element: <DashboardTab />
  },
  {
    path: 'map',
    element: mapsApiKey ? (
      <APIProvider apiKey={mapsApiKey}>
        <MapOverviewTab />
      </APIProvider>
    ) : (
      <></>
    )
  },
  JobsRoutes,
  RaptorJobRoutes,
  JobSitesRoutes,
  EmployeesRoutes,
  EquipmentRoutes,
  CustomersRoutes,
  QuotesRoutes,
  AnalyticsRoutes,
  DashboardRoutes,
  TimesheetsRoutes,
  CertPermRoutes,
  UserManagementRoutes,
  ...(isRunningLocally()
    ? [
        {
          path: 'user-preferences',
          element: <UserPreferencesPage />
        }
      ]
    : []),
  {
    path: '*',
    element: <NotFound />
  }
];

const MainRoutes = {
  path: '/',
  errorElement: <SomethingWentWrong />,
  element: (
    <AuthGuard>
      <Layout />
    </AuthGuard>
  ),
  children: [...MainRaptorRoutes]
};

export default MainRoutes;
